import { Injectable } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { TranslateService } from '@ngx-translate/core';
import { HEROKU_BOOMERANG_BAR_HEIGHT } from '../../constants/app';

@Injectable({
  providedIn: 'root',
})
export class OldNotifyService {
  private previousMessage = '';
  private notifyRef;

  constructor(private translate: TranslateService) {}

  public alert(title, message, iconType, options) {
    const isPreviousNotifyVisible = this.notifyRef && document.contains(this.notifyRef.$ele[0]);
    if (!isPreviousNotifyVisible) {
      this.previousMessage = '';
    }

    if (options.mergeError && isPreviousNotifyVisible) {
      const tempElement = document.createElement('div');
      tempElement.innerHTML = message;
      if (!this.previousMessage.includes(tempElement.innerText)) {
        this.notifyRef.update('message', `${this.previousMessage}<br>${message}`);
      }
      return;
    }
    const iconClassMap = {
      success: 'fa-check',
      warning: 'fa-exclamation',
      danger: 'fa-exclamation',
      info: 'fa-info',
    };
    const iconClass = iconClassMap[iconType];
    const iconTemplate = `<span data-notify="icon"><span class="fa-stack"><i class="fa fa-circle-thin fa-stack-2x"></i><i class="fa ${iconClass} fa-stack-1x"></i></span></span> `;
    const defaults = {
      placement: {
        from: 'top',
        align: 'center',
      },
      type: 'info',
      z_index: 5000,
      delay: 3000,
      style: 'bootstrap',
      animate: {
        enter: 'animated fadeInDown',
        exit: 'animated fadeOutUp',
      },
      container_class: 'col-xs-11 col-sm-4 col-md-4',
    };

    const newOptions = { ...defaults, ...options };

    const DEFAULT_OFFSET = 20;

    if ($('body').hasClass('heroku-boomerang-loaded') && newOptions.placement.from === 'top') {
      newOptions.offset = { y: DEFAULT_OFFSET + HEROKU_BOOMERANG_BAR_HEIGHT };
    }

    // Set template which can't be overriden
    newOptions.template =
      `<div data-notify="container" class="notify alert alert-{0} alert-dismissible ${newOptions.container_class}" role="alert">` +
      '<button type="button" class="close" data-dismiss="alert" aria-label="Close" data-notify="dismiss">' +
      '  <span aria-hidden="true">&times;</span>' +
      '</button>' +
      `<h4 class="alert-heading" data-notify="title">${title != null ? iconTemplate : ''}{1}</h4>` +
      `<p data-notify="message">${title === null ? iconTemplate : ''}<span class="message">{2}</span></p>` +
      '</div>';

    this.previousMessage = message;

    this.notifyRef = ($ as any).notify(
      {
        title,
        message: $('<textarea />').html(message).text(),
        icon_type: 'class',
        icon: iconType != null ? '' : 'hidden',
      },
      newOptions,
    );
  }

  public alertModal(title, message, iconType, options) {
    const defaults = {
      element: '.modal-body',
      placement: {
        from: 'bottom',
        align: 'center',
      },
      offset: {
        y: 100,
      },
      delay: 7000,
      animate: {
        enter: 'animated fadeInUp',
        exit: 'animated fadeOut',
      },
      container_class: 'col-xs-11 col-sm-11 col-md-11',
    };

    this.alert(title, message, iconType, { ...defaults, ...options });
  }

  public log(title, message) {
    this.alert(title, message, null, { type: 'danger' });
  }

  public error(title, message) {
    this.alert(title, message, 'danger', { type: 'danger', delay: 7000 });
  }

  public info(title, message) {
    this.alert(title, message, 'info', { type: 'info', delay: 5000 });
  }

  public success(title, message) {
    this.alert(title, message, 'success', { type: 'success', delay: 3000 });
  }

  public warn(title, message) {
    this.alert(title, message, 'warning', { type: 'warning', delay: 7000 });
  }

  public jobSubmitted(job) {
    const message = this.translate.instant('job.notifications.submitted.message', {
      id: job.id,
      package: job.package.name,
      cluster: job.cluster.name,
      creator: job.creator.display_name,
    });
    this.alert(null, message, 'success', { type: 'info', delay: 7000 });
  }
}

((window as any).xplenty as angular.IModule).service('notify', downgradeInjectable(OldNotifyService));
